import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="fade-in">
      <div className="card">
        <h1>Welkom bij de Hypotheek Calculator</h1>
        <p>
          Bereken eenvoudig uw hypotheekmogelijkheden met onze professionele calculators.
          Of u nu kiest voor een annuïteitenhypotheek of een lineaire hypotheek,
          wij helpen u de juiste keuze te maken.
        </p>
        <div className="alert alert-warning">
          <strong>Let op:</strong> Alle berekeningen zijn louter indicatief. Voor een nauwkeurige berekening en het verkennen van andere opties, <Link to="/contact">neem contact op met De Heer</Link>. Voor algemene budgetteringsvraagstukken kunt u ook terecht bij <a href="https://www.nibud.nl/" target="_blank" rel="noopener noreferrer">NIBUD</a>.
        </div>
      </div>

      <div className="grid grid-2">
        <div className="card">
          <h2>Annuïteitenhypotheek Calculator</h2>
          <p>
            Bij een annuïteitenhypotheek betaalt u elke maand hetzelfde bedrag.
            In het begin bestaat dit hoofdzakelijk uit rente, later meer uit aflossing.
          </p>
          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li>Vaste maandlasten gedurende de hele looptijd</li>
            <li>Lagere maandlasten aan het begin</li>
            <li>Geschikt voor starters en mensen met een krappe begroting</li>
            <li>NHG-ondersteuning beschikbaar</li>
          </ul>
          <Link to="/annuity-calculator" className="btn btn-primary">
            Start Annuïteiten Calculator
          </Link>
        </div>

        <div className="card">
          <h2>Lineaire Hypotheek Calculator</h2>
          <p>
            Bij een lineaire hypotheek lost u elke maand hetzelfde bedrag af.
            De rente daalt dus elke maand, waardoor uw maandlasten afnemen.
          </p>
          <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
            <li>Aflopende maandlasten over de tijd</li>
            <li>Hogere maandlasten aan het begin</li>
            <li>Minder hypotheekrente aftrekbaar</li>
            <li>Strengere toetsing door hoge startlasten</li>
            <li>Minder ruimte voor andere uitgaven</li>
            <li><strong>Lagere maximale hypotheek</strong> vanwege hogere initiële betalingen</li>
          </ul>
          <Link to="/linear-calculator" className="btn btn-secondary">
            Start Lineaire Calculator
          </Link>
        </div>
      </div>

      <div className="grid grid-2">
        <div className="card">
          <h2>Rente Analyse</h2>
          <p>
            Bekijk de ontwikkeling van hypotheekrente over tijd en zie hoe verschillende
            rentepercentages uw maandlasten beïnvloeden.
          </p>
          <Link to="/interest-rates" className="btn btn-secondary">
            Bekijk Rente Grafieken
          </Link>
        </div>


      </div>

      <div className="card">
        <h2>Hypotheek Vocabulaire</h2>
        <div className="grid grid-3">
          <div>
            <h3>NHG (Nationale Hypotheek Garantie)</h3>
            <p>
              De NHG biedt zekerheid bij het afsluiten van uw hypotheek.
              Met NHG krijgt u vaak een lagere rente en extra bescherming bij financiële tegenslag.
            </p>
            <a href="https://www.nhg.nl/" target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline">
              Meer info NHG
            </a>
          </div>
          <div>
            <h3>Energielabel Voordeel</h3>
            <p>
              Woningen met een goed energielabel kunnen meer hypotheek krijgen.
              Ons systeem berekent automatisch uw energiebonus.
            </p>
            <a href="https://www.nibud.nl/nieuws/energielabel-vanaf-2024-bepalend-voor-hoogte-maximale-hypotheek/" target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline">
              Info Energielabel
            </a>
          </div>
          <div>
            <h3>Kosten Koper</h3>
            <p>
              Vergeet niet de kosten koper (notaris, overdrachtsbelasting, taxatie)
              mee te nemen in uw berekening.
            </p>
            <a href="https://www.funda.nl/meer-weten/kopen/wat-zijn-kosten-koper/" target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline">
              Kosten Koper Info
            </a>
          </div>
        </div>
        <div className="grid grid-2" style={{ marginTop: '1.5rem' }}>
          <div>
            <h4>Wet Hillen</h4>
            <p>
              Regeling die ervoor zorgt dat u minder eigenwoningforfait hoeft te betalen
              als uw hypotheekschuld lager is dan de WOZ-waarde van uw woning.
            </p>
            <a href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/woning/eigenwoningforfait/" target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline">
              Meer over Wet Hillen
            </a>
          </div>
          <div>
            <h4>Eigenwoningforfait (EWF)</h4>
            <p>
              Het bedrag dat jaarlijks wordt toegevoegd aan uw belastbaar inkomen
              als u eigenaar bent van een woning. Gebaseerd op de WOZ-waarde.
            </p>
            <a href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/woning/eigenwoningforfait/" target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline">
              EWF Berekening
            </a>
          </div>
          <div>
            <h4>Woonquote</h4>
            <p>
              Ook wel de financieringslastpercentage. Het percentage van uw netto inkomen dat u besteedt aan woonlasten.
              Een gezonde woonquote ligt tussen de 25% en 40%.
            </p>
            <a href="https://www.nibud.nl/onderzoeksrapporten/rapport-advies-hypotheeknormen-2025-nibud-2024/" target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline">
              NIBUD Woonquote
            </a>,
            <a href="https://www.nhg.nl/media/h00jkdyo/vn-nhg-2025-bijlage-5-financieringslasttabel-beheer.pdf" target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline">
              Woonquote tabel
            </a>
          </div>
          <div>
            <h4>Loan-to-Value (LTV)</h4>
            <p>
              De verhouding tussen het hypotheekbedrag en de waarde van de woning.
              In Nederland is de maximale LTV meestal 100%.
            </p>
          </div>
          <div>
            <h4>Loan-to-Income (LTI)</h4>
            <p>
              De verhouding tussen het hypotheekbedrag en uw jaarlijkse bruto inkomen.
              Dit bepaalt hoeveel u maximaal kunt lenen. In de Nederlandse context is dit de financieringslastpercentage.
            </p>
            <a href="https://www.afm.nl/nl-nl/consumenten/themas/hypotheken/hypotheek-betalen" target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline">
              Leenregels AFM
            </a>
          </div>
          <div>
            <h4>Hypotheekrente Aftrek</h4>
            <p>
              Belastingvoordeel waarbij u de betaalde hypotheekrente kunt aftrekken
              van uw belastbaar inkomen.
            </p>
            <a href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/inkomstenbelasting/aftrekposten/hypotheekrenteaftrek/" target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline">
              Hypotheekrente Aftrek
            </a>
          </div>
        </div>
      </div>

      <div className="card">
        <h2>Aanvullende Informatie</h2>
        <div className="grid grid-2">
          <div>
            <h3>NIBUD - Budgetadvies</h3>
            <p>
              Het Nationaal Instituut voor Budgetvoorlichting (NIBUD) is een onafhankelijke organisatie
              die consumenten helpt met budgetadvies en financiële planning.
              Zij bieden gratis tools en informatie voor het maken van een huishoudbudget.
            </p>
            <a
              href="https://www.nibud.nl/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary"
            >
              Bezoek NIBUD
            </a>
          </div>
          <div>
            <h3>Persoonlijk Advies</h3>
            <p>
              Voor persoonlijk hypotheekadvies en het verkennen van alle beschikbare opties
              staat DeHeer voor u klaar. Neem contact op voor een vrijblijvend adviesgesprek.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Contact DeHeer
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
